import "./Result.scss";
import { imageKeyMappings } from "../../../assets/images/imageKeyMappings";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import PubSub from "pubsub-js";
import Info from "../../shared/info/InfoPopup";
import { useLocation } from "react-router-dom";
import { userId } from "../loader/Loader";
import { APILOG } from "../../../config/services/Analytics";
import { eventTrack } from "../../../config/utils/GaTags";
import { GET_PROFILE } from "../../../config/services/profileService";
import { getWheelInfo } from "../../../config/services/spinService";
import Lottie from 'react-lottie';
import * as confettiAnimation from "../../../assets/lottie/confetti-lottie.json";

function Result() {
  const [showInfoPopup, setInfoPopup] = useState(false);
  const [infoData, setInfoData] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const prizes = location.state?.prizes;
  const uiConfig = location.state?.uiConfig;
  const [profile, setProfile] = useState("");
  const [spinInfo, setSpinInfo] = useState("");
  const [spinExhaust, setSpinExhaust] = useState(false);
  const [isNavigating, setIsNavigating] = useState(false);
   
// eventTrack = (event, pageTitle, params)
// APILOG =     (page_title, event, params) 
  useEffect(() => {
    console.log(prizes, "prize");
    // APILOG('reward_page', 'gratification', {coupon_id: prizes?.prize?.id, coupon_name: prizes?.prize?.name})

    const infoPopUp = PubSub.subscribe("closeInfoPopup", toggleInfoPopup);
    setInfoData(prizes?.prize);

    prizes?.prize?.type === "BLNT"
      ? eventTrack("pageload", "better_luck_next_time_page")
      : prizes?.userAlreadyWon
      ? eventTrack("pageload", "secured_already_page")
      : eventTrack("pageload", "reward_page");

    prizes?.prize?.type === "BLNT"
      ? APILOG("better_luck_next_time_page", "pageload",{wheel_id:prizes.wheelID})
      : prizes?.userAlreadyWon
      ? APILOG( "secured_already_page", "pageload",{wheel_id:prizes.wheelID})
      : APILOG("reward_page", "pageload",{wheel_id:prizes.wheelID});

    if (prizes?.prize?.type !== "BLNT" && !prizes?.userAlreadyWon) {
      eventTrack("gratification", "reward_page", {
        plan_id: prizes?.prize?.id,
      });
    }
    return () => {
      PubSub.unsubscribe(infoPopUp);
    };
  }, []);

  const getProfile = async () => {
    try {
      const response = await GET_PROFILE();
      setProfile(response?.data);
    } catch (error) {
      console.error("Error fetching data:", error);
      navigate("/fallback", { state: { error: error.message } });
    }
  };

  useEffect(() => {
    getProfile();
    getSpinInfo();
  }, []);

  const toggleInfoPopup = () => {
    setInfoPopup((prevState) => {
        const newState = !prevState; 
        if (newState) { 
            eventTrack("select_option", "reward_page", {
                event_action: "instructions",
            });
            //APILOG("reward_page", "instructions", { wheel_id: prizes.wheelID });
            APILOG("instruction_pop_up_page", "pageload", { wheel_id: prizes.wheelID });
        }else{
          APILOG("instruction_pop_up_page", "cancel", { wheel_id: prizes.wheelID });
        }
        return newState; 
    });
};

  const getSpinInfo = async () => {
    try {
      const response = await getWheelInfo();
      setSpinInfo(response);
    } catch (error) {
      if (error.response.data.customCode) {
        setSpinExhaust(true);
      } else {
        navigate("/fallback", { state: { error: error.message } });
      }
    }
  };

  const handleLoginClaim = () => {
    try {
      eventTrack("select_option", "reward_page", {
        event_action: "login_claim",
      });
      APILOG("reward_page","login_claim",{wheel_id:prizes.wheelID})
      console.log("login", process.env.REACT_APP_DOMAIN_URL);
      window.parent.postMessage("login", process.env.REACT_APP_DOMAIN_URL);
    } catch (error) {
      window.postMessage("login", process.env.REACT_APP_DOMAIN_URL);
    }
  };

  const navigateTo = (data) => { 
    setIsNavigating(true);
    setTimeout(() => {
      switch (data) {
      case "spin-again":
        //APILOG("reward_page", "dial_again",{wheel_id:prizes.wheelID});

        eventTrack(
          "select_option",
          `${
            prizes?.prize?.type === "BLNT"
              ? "better_luck_next_time_page"
              : prizes?.userAlreadyWon
              ? "secured_already_page"
              : "reward_page"
          }`,
          {
            event_action: "dial_again",
          }
        );

        APILOG(
          `${ prizes?.prize?.type === "BLNT"
              ? "better_luck_next_time_page"
              : prizes?.userAlreadyWon
              ? "secured_already_page"
              : "reward_page"
          }`, "dial_again",{wheel_id:prizes.wheelID}
        );

        navigate("/home");
        break;

      case "vouchers":
        APILOG("reward_page", "my_vouchers",{wheel_id:prizes.wheelID});
        eventTrack(
          "select_option",
          `${
            prizes?.prize?.type === "BLNT"
              ? "better_luck_next_time_page"
              : prizes?.userAlreadyWon
              ? "secured_already_page"
              : "reward_page"
          }`,
          {
            event_action: "my_vouchers",
          }
        );
        if (process.env.REACT_APP_ENVIRONMENT == "dev") {
          window.location.href = `https://jioplayalong4.akamaized.net/tiramywinning/index.html?userId=${userId()}&platform=tirabeauty&engagement=spin2win`;
        } else {
          window.location.href = `https://jioplayalong5.akamaized.net/tiramywinning/index.html?userId=${userId()}&platform=tirabeauty&engagement=spin2win`;
        }
        console.log("Navigate to My Vouchers");
        break;
      }
      setIsNavigating(false);
    },50)
  };

  const lottieOptions = {
    loop: true,
    autoplay: true, 
    animationData: confettiAnimation,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  };

  return (
    <>
      {isNavigating ? (
        <>
          <div className="loader-overlay">
            <div className="loader"></div>
          </div>
        </>
      ) : (
        <React.Fragment>
          <div className="result-page">
            <div className="wrapper">
              <div className="header">
                <div className="spin-text">{uiConfig?.homepageTitleText}</div>
                <div className="reward-text">
                  {uiConfig?.homepageSubTitleText}
                </div>
              </div>
              <div className="gratification-content">
                <div className="gratification-bg">
                  <div className="gift-icon">
                    <img
                      src={
                        prizes?.prize?.type === "BLNT"
                          ? imageKeyMappings?.dialAgain
                          : imageKeyMappings.resultGiftIcon
                      }
                      alt={
                        prizes?.prize?.type === "BLNT"
                          ? "dial again image"
                          : "reward image"
                      }
                    />
                  </div>

                  <div
                    className="nailed-text"
                    dangerouslySetInnerHTML={{
                      __html:
                        prizes?.prize?.type === "BLNT"
                          ? "Spin Again"
                          : prizes && !prizes?.userAlreadyWon
                          ? "Congratulations!"
                          : "You've already won<br/> this voucher",
                    }}
                  ></div>

                  <div
                    className="desc-text"
                    dangerouslySetInnerHTML={{
                      __html:
                        prizes?.prize?.type === "BLNT"
                          ? "Give the beauty wheel of fortune one more shot!"
                          : prizes && !prizes?.userAlreadyWon
                          ? "You have won"
                          : "Spin again to collect 'em all!",
                    }}
                  ></div>

                  <div className="coupon-desc">
                    {prizes && !prizes?.userAlreadyWon && prizes?.prize?.type !== "BLNT"
                      ? prizes?.prize?.desc
                      : ""}
                  </div>

                  {prizes?.prize?.type != "BLNT" && (
                    <div className="info-icon" onClick={toggleInfoPopup}>
                      <img src={imageKeyMappings.infoIcon} alt="Info icon" />
                    </div>
                  )}
                </div>
              </div>
              {!showInfoPopup ? (
                <div className="bottom-content">
                  {profile && !profile?.userId ? (
                    prizes?.prize?.type !== "BLNT" ? (
                      <div className="spin-cta" onClick={handleLoginClaim}>
                        Log in to claim
                      </div>
                    ) : (
                      <div
                        className="spin-cta"
                        onClick={() => navigateTo("spin-again")}
                      >
                        {location?.state?.uiConfig?.spinAgainCtaText}
                      </div>
                    )
                  ) : (
                    <>
                      {profile &&
                        profile?.TnC &&
                        !spinExhaust &&
                        profile?.userId && (
                          <div className="attempts-left">
                            You have{" "}
                            <span>
                              {spinInfo?.spinsLeft}/{spinInfo?.totalSpins}
                            </span>{" "}
                            attempts left
                          </div>
                        )}
                      {spinExhaust && (
                        <div className="max-attempt">
                         You've maxed out on your attempts for the day.
                          <br />
                          Please try again tomorrow!
                        </div>
                      )}
                      {profile && profile?.userId && (
                        <div className="bottom-wrapper">
                          <div className="left">
                            <div
                              className={
                                spinExhaust ? "disabled" : "spin-button"
                              }
                              onClick={() => navigateTo("spin-again")}
                            >
                              <div className="spin-text">
                                {location?.state?.uiConfig?.spinAgainCtaText}
                              </div>
                            </div>
                          </div>
                          <div
                            className="right"
                            onClick={() => navigateTo("vouchers")}
                          >
                            <div className="voucher-button">
                              <div className="voucher-text">My Vouchers</div>
                            </div>
                          </div>
                        </div>
                      )}
                    </>
                  )}
                </div>
              ) : (
                <Info data={infoData}></Info>
              )}
              {prizes?.prize?.type !== "BLNT" &&
              prizes &&
              !prizes?.userAlreadyWon ? (
                <div className="confetti-container">
                  <Lottie
                    options={lottieOptions}
                    height={"100%"}
                    width={"100%"}
                  />
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        </React.Fragment>
      )}
    </>
  );
}

export default Result;
